import { Observable } from 'rxjs';

export abstract class BaseAciService {
  public abstract sendSurvey(formdata: any);
  public abstract updateAciSearchResults(aciSurveyResults: any[], rawResults: any[], uuid: string): Observable<any>;
  public abstract resetAciSurvey(uuid: string): Observable<any>
  public abstract deleteAciData(uuid: string): Observable<any>;
}
